import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button } from '@airia/ui';
import { Mail } from 'lucide-react';
import { stripHtml } from '../../lib/stripHtml';
import { formatEmailBody } from '../../lib/formatEmailBody';
const EmailButton = ({ emailData }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const plainTextBody = stripHtml(emailData.body);
    const shouldShowToggle = plainTextBody.length > 100;
    const handleCreateEmail = async () => {
        try {
            if (typeof Office !== 'undefined' && Office.context.mailbox) {
                // Create new email using Office.js Outlook API
                const displayNewMessageForm = Office.context.mailbox.displayNewMessageForm;
                if (displayNewMessageForm) {
                    const emailOptions = {
                        toRecipients: [emailData.to],
                        subject: emailData.subject,
                        htmlBody: formatEmailBody(emailData.body),
                    };
                    // Add CC recipients if provided
                    if (emailData.cc) {
                        // Parse CC recipients (they might be comma-separated)
                        const ccRecipients = emailData.cc
                            .split(',')
                            .map((email) => email.trim())
                            .filter((email) => email);
                        if (ccRecipients.length > 0) {
                            emailOptions.ccRecipients = ccRecipients;
                        }
                    }
                    displayNewMessageForm(emailOptions);
                }
                else {
                    console.error('displayNewMessageForm not available');
                }
            }
            else {
                console.error('Office context not available');
            }
        }
        catch (error) {
            console.error('Error creating email:', error);
        }
    };
    return (_jsxs("div", { className: "my-2 p-3 bg-primary/5 border border-primary/20 rounded-lg", children: [_jsxs("div", { className: "flex items-start gap-3", children: [_jsx("div", { className: "p-2 bg-primary/10 rounded-full", children: _jsx(Mail, { className: "size-4 text-primary" }) }), _jsxs("div", { className: "flex-1 min-w-0", children: [_jsx("div", { className: "text-sm font-medium text-foreground mb-1", children: "New Email Draft" }), _jsxs("div", { className: "text-xs text-muted-foreground space-y-1", children: [_jsxs("div", { children: [_jsx("span", { className: "font-medium", children: "To:" }), " ", emailData.to] }), emailData.cc && (_jsxs("div", { children: [_jsx("span", { className: "font-medium", children: "CC:" }), " ", emailData.cc] })), _jsxs("div", { children: [_jsx("span", { className: "font-medium", children: "Subject:" }), " ", emailData.subject] }), _jsxs("div", { className: isExpanded ? '' : 'max-h-20 overflow-y-auto', children: [_jsx("span", { className: "font-medium", children: "Body:" }), ' ', isExpanded ? plainTextBody : plainTextBody.substring(0, 100), !isExpanded && shouldShowToggle && '...'] }), shouldShowToggle && (_jsx("button", { onClick: () => setIsExpanded(!isExpanded), className: "text-primary hover:underline text-xs mt-1", children: isExpanded ? 'Show Less' : 'Show More' }))] })] })] }), _jsxs(Button, { onClick: handleCreateEmail, size: "sm", className: "w-full mt-3", children: [_jsx(Mail, { className: "size-4 mr-2" }), "Create Email"] })] }));
};
export default EmailButton;
